/* main.js: 需注意要在Vue.use(ElementUI)后使用
   import { $message } from "./extend/ElMessage/ElMessageExtend";
   Vue.prototype.$message = $message才可以生效
*/
import { Message } from 'element-ui'

const IS_MICRO_APP_ENVIRONMENT = window.__MICRO_APP_ENVIRONMENT__ // 微服务环境
export let $message

if (IS_MICRO_APP_ENVIRONMENT) {
    const microAppMessage = option => {
        return window.microApp.forceDispatch(option)
    }

    $message = microAppMessage;

    ['success', 'warning', 'info', 'error'].forEach(type => {
        $message[type] = option => {
            if (typeof option === 'string') {
                option = { message: option }
            }
            option.type = type
            return microAppMessage(option)
        }
    })
} else {
    $message = option => {
        return Message({
            ...option,
            offset: 80
        })
    }

    ['success', 'warning', 'info', 'error'].forEach(type => {
        $message[type] = option => {
            if (typeof option === 'string') {
                option = {
                    message: option,
                    offset: 80
                }
            }
            option.type = type
            return Message(option)
        }
    })
}
